import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

export class Rate {
  rate: number;
  amount: number;
  sourceCurrency: string;
  destinationCurrency: string;
}

@Injectable({
  providedIn: 'root'
})
export class RateService {

  constructor(private http: HttpClient) {
    if(environment.apiBase.includes('localhost')){
      console.warn('Using local backend. Dont forget to use hosted backend instead');
    }
  }

  getRate(sourceCurrency: string, destinationCurrency: string, amount: number, reverse): Observable<Rate> {
    return this.http.get<Rate>(`${environment.apiBase}/rates/${sourceCurrency}/${destinationCurrency}/${amount}/${reverse}`);
  }
}
